export default __webpack_public_path__ + "static/media/flag-azores-islands.546bf174.svg";